import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Obfuscate from "react-obfuscate";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
/*import Form from "../components/ContactForm";*/
import config from "../../content/meta/config";
import Footer from "../components/Footer/Footer";

const styles = theme => ({});

const Contact = () => {
  return (
    <Main>
      <Article>
        <PageHeader title="Contact" />
        <Content>
          Have you made a new surf helmet or simply, a water-tight helmet that you think could be
          used surfing? Please contact me! You can reach me by email:{" "}
          <Obfuscate email={config.contactEmail} />.
          <br />
          <br />
          I'm also very interested in other surfer's experiences while using these helmets, or any
          other helmets capable of getting in the surf that I've missed (<a
            href="https://issuu.com/f-one/docs/ocean_helmets_2012"
            target="_blank"
          >
            I know of one
          </a>, but it's no longer available). If you are interested in providing a review or
          testimonial, please email me!
          <br />
          <br />
          I'm also happy to address any other comments, questions or concerns.
        </Content>
        {/*<Form />*/}
      </Article>
      <Footer />
    </Main>
  );
};

Contact.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Contact);



// WEBPACK FOOTER //
// ./src/pages/contact.js